import { ROUTE } from '../routingConfig/routeDetails'

const homeDefaultCategories = [
  {
    id: 'cd',
    label: 'Fresh Vegetables',
    value: 'freshVegetables',
    image: '4-1.jpg',
    link: ROUTE.PESTICIDESBYCATEGORY,
  },
  {
    id: 'fruit',
    label: 'Fresh Fruits',
    value: 'freshFruits',
    image: '5-1.jpg',
    link: ROUTE.PESTICIDESBYCATEGORY,
  },
  {
    id: 'cd1',
    label: 'Crops',
    value: 'crops',
    image: '3-1.jpg',
    link: ROUTE.PESTICIDESBYCATEGORY,
  },
  {
    id: 'cd2',
    label: 'Pulses',
    value: 'pulses',
    image: '2-1.jpg',
    link: ROUTE.PESTICIDESBYCATEGORY,
  },
  {
    id: 'dairy',
    label: 'Dairy Animals',
    value: 'dairyAnimals',
    image: '7-1.jpg',
    link: ROUTE.PESTICIDESBYCATEGORY,
  },
  {
    id: 'domestic',
    label: 'Domestic Animals',
    value: 'domesticAnimals',
    image: '9-1.jpg',
    link: ROUTE.PESTICIDESBYCATEGORY,
  },
]

export default homeDefaultCategories
